import React from 'react';

export default function useImageAspectRatio(imageUrl: string): number | null {
  const [aspectRatio, setAspectRatio] = React.useState<number | null>(null);

  React.useEffect(() => {
    const getImageAspectRatio = async () => {
      try {
        // Create a new image element
        const img = new Image();
        img.src = imageUrl;

        // Wait for the image to load
        await img.decode();

        // Calculate aspect ratio
        const ratio = img.width / img.height;

        // Adjust the ratio based on specific conditions
        let adjustedRatio = Math.min(1, ratio / 1.6);
        if (window.innerWidth < 1000) {
          adjustedRatio = Math.min(
            1,
            ratio / (window.innerHeight < window.innerWidth ? 1.9 : 1.6),
          );
        }

        adjustedRatio = adjustedRatio < 0.78 ? 0.83 : adjustedRatio;
        // Update the state with the adjusted aspect ratio
        setAspectRatio(adjustedRatio);
      } catch (error) {
        console.error('Error loading image aspect ratio:', error);
        setAspectRatio(null);
      }
    };

    // Call the function when the component mounts or when imageUrl changes
    if (imageUrl) {
      getImageAspectRatio();
    } else {
      setAspectRatio(null); // Reset if no imageUrl is provided
    }
  }, [imageUrl]);

  return aspectRatio;
}
